import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const {
    widthDesktopDrawer,
    widthTabletDrawer,
    heightDesktopHeader,
    heightMobileHeader,
    zIndex,
    palette: { primary, secondary, error }
  } = theme;

  return {
    conditionsRoot: {
      [theme.breakpoints.up(Breakpoints.SX_720)]: {
        zIndex: "1219 !important"
      },
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        zIndex: "1220 !important"
      }
    },
    conditionsPaper: {
      width: "100%",
      height: `calc(100% - ${heightDesktopHeader})`,
      margin: 0,
      marginTop: heightDesktopHeader,
      marginLeft: widthDesktopDrawer,
      borderRadius: 0,
      boxShadow: "none",
      maxWidth: "unset",
      borderLeft: `1px solid ${primary.light}`,
      [theme.breakpoints.down(Breakpoints.MD_960)]: {
        marginLeft: widthTabletDrawer
      },
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        margin: 0,
        width: "100%",
        height: "100%",
        borderLeft: "none"
      }
    },
    conditionsTitleRoot: {
      padding: 0,
      borderBottom: `1px solid ${primary.light}`
    },
    conditionsContentRoot: {
      padding: 0,
      display: "flex",
      flexDirection: "column"
    },
    conditionsActionsRoot: {
      height: "69px",
      padding: 20,
      borderTop: `1px solid ${primary.light}`,
      display: "flex",
      justifyContent: "center",
      [theme.breakpoints.down(Breakpoints.MD_960)]: {
        height: "110px"
      },
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        height: "94px"
      }
    },
    controlsButtonsContainer: {
      width: 668,
      display: "flex",
      justifyContent: "flex-end"
    },
    conditionsNoteBlock: {
      padding: 0,
      margin: 0,
      maxWidth: "unset"
    },
    buttonsContainer: {
      display: "grid",
      gridGap: 12
    },
    raceDistancesButtons: {
      gridTemplateColumns: "repeat(7, 1fr)",
      [theme.breakpoints.down(Breakpoints.MD_960)]: {
        gridTemplateColumns: "repeat(6, 1fr)"
      },
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        gridTemplateColumns: "repeat(4, 1fr)"
      }
    },
    conditionSwitchHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    conditionSwitch: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gridGap: 20,

      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        gridGap: 14
      }
    },
    condition: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifySelf: "flex-start",
      padding: "0 16px",
      "&:first-child": {
        justifySelf: "flex-end"
      },
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        padding: 0,
        justifySelf: "center"
      }
    },
    conditionHintButton: {
      top: -8,
      width: 32,
      height: 32,
      marginRight: -8
    },
    conditionsHint: {
      "& .MuiDialog-container": {
        marginLeft: widthDesktopDrawer,
        [theme.breakpoints.down(Breakpoints.MD_960)]: {
          marginLeft: widthTabletDrawer
        },
        [theme.breakpoints.down(Breakpoints.SM_600)]: {
          marginLeft: 0
        }
      },
      "& .MuiPaper-root": {
        maxWidth: 320,
        padding: "24px 24px 12px 24px"
      }
    },
    conditionsHintHeader: {
      padding: "0 0 8px 0",
      letterSpacing: "-0.3px",

      "& .MuiTypography-root": {
        lineHeight: "20px",
        fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
        fontSize: 18
      }
    },
    conditionsHintContent: {
      padding: 0
    },
    conditionsHintFooter: {
      padding: 0
    },
    switchButton: {
      width: 61,
      height: 36,
      borderRadius: 64,
      border: `1px solid ${primary.light}`
    },
    lastRaceActiveButton: {
      backgroundColor: "#81daf9",
      borderColor: "#48769b",

      "&:hover": {
        backgroundColor: "#81daf9"
      }
    },
    customRaceActiveButton: {
      backgroundColor: "#f0e3bf",
      borderColor: "#998765",

      "&:hover": {
        backgroundColor: "#f0e3bf"
      }
    },
    lastRaceIcon: {
      width: 28,
      height: 16,
      overflow: "visible",
      color: primary.light,
      "&.active": {
        color: "#48769B"
      }
    },
    customRaceIcon: {
      width: 36,
      height: 22,
      overflow: "visible",
      color: primary.light,
      "&.active": {
        color: "#998765"
      }
    },
    switchButtonTitle: {
      color: primary.light,
      marginTop: 9,
      lineHeight: "27px",
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      fontSize: 14,
      textAlign: "center"
    },
    switchButtonActiveTitle: {
      color: "#403d33"
    },
    conditionsButtons: {
      gridTemplateColumns: "repeat(5, 1fr)",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        gridTemplateColumns: "repeat(3, 1fr)"
      }
    },
    appPageHeader: {
      top: 0,
      height: "70px",
      zIndex: zIndex.app?.logo + 1,
      position: "fixed",
      boxShadow: "0 3px 6px -3px rgba(0, 0, 0, 0.2)",
      width: `calc(100% - ${widthDesktopDrawer})`,
      [theme.breakpoints.down(Breakpoints.MD_960)]: {
        width: `calc(100% - ${widthTabletDrawer})`
      },
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        width: "100%"
      }
    },
    overlay: {
      display: "flex",
      flexDirection: "column",
      position: "absolute",
      top: 70 - heightDesktopHeader,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: zIndex.page?.overlay - 2,
      background: "#fff",
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        top: 70 - heightMobileHeader
      }
    },
    overlayContent: {
      flexGrow: 1,
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: "#fff"
    },
    overlayControls: {
      justifyContent: "flex-end",
      padding: 24,
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        justifyContent: "space-between",
        padding: 16
      }
    },
    overlayControl: {
      display: "flex",
      maxWidth: 588,
      height: 46,
      borderRadius: 3,
      fontSize: 16,
      boxSizing: "border-box",
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      textAlign: "center",
      overflow: "hidden"
    },
    overlayCancel: {
      width: 238,
      backgroundColor: "#fff",
      color: primary.dark,
      border: `1px solid ${primary.light}`,
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        width: "calc(40% - 7px)"
      }
    },
    overlaySave: {
      width: 324,
      border: `1px solid ${primary.main}`,
      backgroundColor: primary.main,
      color: theme.palette.common.white,
      marginLeft: 14,
      [theme.breakpoints.down("xs")]: {
        width: "calc(60% - 7px)"
      },
      "&:hover": {
        backgroundColor: primary.main
      }
    },
    block: {
      width: "100%",
      maxWidth: 668,
      paddingTop: 24,
      paddingBottom: 24,
      alignSelf: "center",
      [theme.breakpoints.down(Breakpoints.SX_720)]: {
        padding: 20
      },
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        padding: "20px 16px"
      },
      "&:first-child": {
        paddingBottom: "24px 20px 18px",
        [theme.breakpoints.down(Breakpoints.SM_600)]: {
          padding: "20px 16px 12px"
        }
      }
    },
    title: {
      textAlign: "left",
      lineHeight: "normal",
      marginBottom: 12,
      marginLeft: 0
    },
    conditionSwitchTitle: {
      lineHeight: "23px",
      marginBottom: 18
    },
    surfaceButtons: {
      display: "flex",
      gridTemplateColumns: "1fr 1fr",
      gridGap: 20,
      margin: "6px 0",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        gridGap: 14
      }
    },
    surfaceButton: {
      width: "100%",
      flex: "auto",
      height: 40,
      borderRadius: 3,
      border: `1px solid ${primary.light}`,
      textTransform: "none",
      flexGrow: 1
    },
    distanceButton: {
      height: 40,
      borderRadius: 20,
      border: `1px solid ${primary.light}`,
      margin: 0
    },
    conditionButton: {
      minWidth: 108,
      height: 40,
      borderRadius: 20,
      border: `1px solid ${primary.light}`,
      [theme.breakpoints.up(Breakpoints.SS_320)]: {
        minWidth: 104
      }
    },
    active: {
      "&&": {
        backgroundColor: "#f0e3bf",
        borderColor: "#998765"
      }
    },
    lastRaceActive: {
      "&&": {
        backgroundColor: "#81daf9",
        borderColor: "#48769b"
      }
    },
    confirmationDialog: {
      "& .MuiDialogTitle-root": {
        maxHeight: 56
      },
      "& .MuiPaper-root": {
        maxWidth: 340,
        [theme.breakpoints.up(Breakpoints.SM_600)]: {
          marginLeft: `calc(${widthTabletDrawer}px + env(safe-area-inset-left))`
        },
        [theme.breakpoints.up(Breakpoints.LG_1280)]: {
          marginLeft: `calc(${widthDesktopDrawer}px + env(safe-area-inset-left))`
        }
      },
      "& .MuiDialogContent-root, & .MuiDialogTitle-root": {
        paddingLeft: 20,
        paddingRight: 20
      },
      "& .MuiDialogContent-root": {
        paddingTop: 0,
        paddingBottom: 16
      },
      "& .MuiDialogActions-root": {
        paddingTop: 0,
        paddingLeft: 10,
        paddingRight: 10,
        paddingBottom: 10
      }
    },
    dialogTitleTypography: {
      fontSize: 20,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      lineHeight: "normal",
      color: primary.main
    },
    dialogContentText: {
      fontSize: 14
    },
    dialogContentBold: {
      fontSize: 14,
      color: primary.main,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
    },
    confirmationDialogActions: {
      justifyContent: "flex-end"
    },
    button: {
      fontSize: 14,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
    },
    disabled: {
      color: primary.light,
      backgroundColor: "#eee",
      borderColor: primary.light
    },
    disabledSaveButton: {
      color: primary.light,
      backgroundColor: "#eee",
      pointerEvents: "none",
      borderColor: "#eee"
    },
    reset: {
      color: error.main
    },
    cancel: {
      color: primary.dark
    },
    divider: {
      width: "100%"
    },
    unsavedModalHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    closeButton: {
      padding: 0
    },
    saveConditions: {
      color: secondary.dark
    },
    actionButtonsContainer: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%"
    },
    claimingPriceButtons: {
      display: "flex",
      flexWrap: "wrap",
      gap: 12,
      [theme.breakpoints.up(Breakpoints.SS_320)]: {
        gap: 8
      }
    },
    claimingPrice: {
      whiteSpace: "nowrap",
      flexGrow: "1",
      [theme.breakpoints.up(Breakpoints.SS_320)]: {
        minWidth: 90
      }
    }
  };
});
